import { useFirebaseAuth } from "@/hooks/use-firebase-auth";
import { Redirect, useLocation } from "wouter";
import { UserRole } from "@/constants/roles";
import { normalizeRoles } from "@/lib/normalize-user-data";

/**
 * Component to redirect users to their appropriate dashboard based on role
 */
function preserveSearch(path: string): string {
  if (typeof window === "undefined") return path;
  const search = window.location.search;
  return search ? `${path}${search}` : path;
}

export function DashboardRedirect() {
  const { user } = useFirebaseAuth();
  const [location] = useLocation();

  // Allow access to login page even when logged in
  if (location === "/auth") {
    return null;
  }

  if (!user) {
    // If not logged in, redirect to auth page
    return <Redirect to="/auth" />;
  }

  // Roles are stored as `profile.roles` (and legacy shapes); normalize covers all.
  const userRoles = normalizeRoles(user);

  if (userRoles.includes(UserRole.ADMIN)) {
    return <Redirect to={preserveSearch("/dashboard")} />;
  }

  // The standard user dashboard now owns role-based feature gating.
  return <Redirect to={preserveSearch("/dashboard")} />;
}
